module.exports = "/assets/data/7984ff950fbd45c653ff5583861651c5-GL10.data.json";